import AnalysesByEmployee from './AnalysesByEmployee/analysesByEmployee';
import BranchApi from 'api/branch';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import TotalWaterAnalyses from './totalAnalyses/totalAnalyses';
import WaterAnalysisAccount from './AnalysisAccount/analysisAccount';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

//Register in router
const render = (container, params) => {
  console.info('[UI.page.reports.water] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperWaterTestReport subPageName={params.subPage} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'reports'});
};

console.info('[UI.page.reports.water] register route');
router.rr.add([{path: 'reports/water/:subPage', handler: routeUtils.requireAdmin(render)}]);

class _WaterTestReport extends Component {
  static propTypes = {
    subPageName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      user: session.getUser(),
      loaded: false,
    };
  }
  componentWillMount() {
    const apis = [];

    apis.push(BranchApi.getMyBranches());
    apis.push(DealerApi.getDealer(this.state.user.dealerId));
    Promise.all(apis)
      .then(([branches, dealer]) => {
        console.log('branches', branches);
        console.log('dealer', dealer);
        this.setState({
          loaded: true,
          dealer: dealer,
          branches: branches.map(b => b.id),
          branchesInfo: branches,
        });
      }).catch(err => {
        console.log('error', err);
      });
  }
  checkPOSPermission() {
    const {user, dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    } else if (user.isDealerAdmin) {
      return true;
    } else if (user.isAdmin && dealer.managerDetailedReporting) {
      return true;
    } else if (user.isTestStation && dealer.testerDetailedReporting) {
      return true;
    } else {
      return false;
    }
  }
  render() {
    let {formatMessage} = this.props.intl;
    const {subPageName} = this.props;
    const {branches, branchesInfo} = this.state;
    const subPages = {
      'total-water-analyses': {name: formatMessage({id: 'general.total.water.analyses'}), element: <TotalWaterAnalyses branches={branchesInfo} POSActive={this.checkPOSPermission()}/>},
      'analysis-accounts': {name: formatMessage({id: 'general.water.analysis.accounts'}), element: <WaterAnalysisAccount branches={branchesInfo} POSActive={this.checkPOSPermission()} />},
      'analyses-by-employee': {name: formatMessage({id: 'general.analyses.employee'}), element: <AnalysesByEmployee branches={branchesInfo} POSActive={this.checkPOSPermission()} />},
    };
    const subPagesTabs = Object.keys(subPages)
      .map(sp => <a key={sp} className={subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
        href={'#reports/water/' + sp}>{subPages[sp].name}
      </a>);
    const subPage = subPages[subPageName].element;

    return (
      <div className='container'>
        <div id='page-reports' >
          <div className='nav-tabs'>
            <Header mainTitle={formatMessage({id: 'reports.title'})} subTitle={formatMessage({id: 'reports.water.analyses'})} mainTitleReturn='reports'/>
          </div>
          <nav className='navigation-tabs'>
            {subPagesTabs}
          </nav>
          <Loader loaded={this.state.loaded}>
            <div className='report-details'>
              {subPage}
            </div>
          </Loader>
        </div>
      </div>
    );
  }
}

const WaterTestReport = bindLocaleUpdate(connectToPerformanceFile(PERFORMANCE_KEYS.reports)(_WaterTestReport));

let WrapperWaterTestReport = injectIntl(WaterTestReport);

export default WaterTestReport;
